// Bridge for the unified login shell (see ADR 0012 in the lajolla repo).
//
// The shell authenticates against /token-auth/ on the user's behalf and leaves
// the response body here; this reads it once on boot and hands it to the normal
// LOGIN_SUCCESSFUL path. The payload is the endpoint's response verbatim --
// { token, user: { ... } } -- because that is exactly what redux/actions/auth.js
// dispatches. Nothing here decodes a JWT: this app reads the user off the
// response body, not out of the token.
//
// This module MUST be inert when the key is absent. Every Moonlight user loads
// this bundle, not just users arriving through the shell, and it ships ahead of
// the router: its success criterion is that nothing changes.

export const HANDOFF_KEY = 'bw_handoff'

export function consumeHandoff() {
  let raw = null

  try {
    raw = window.sessionStorage.getItem(HANDOFF_KEY)
  } catch (err) {
    // Storage disabled or blocked (private mode, cookie policy). Behave exactly
    // as if no handoff were present.
    return null
  }

  if (!raw) return null

  try {
    window.sessionStorage.removeItem(HANDOFF_KEY)
  } catch (err) {
    // Best effort. A stale key is harmless: the token it holds is short-lived
    // and a second read produces the same already-authenticated state.
  }

  try {
    const parsed = JSON.parse(raw)
    // Require both halves the reducer and the components rely on. A payload
    // missing either would produce a session that looks authenticated and then
    // throws on the first render that reads auth.user.
    if (!parsed || typeof parsed.token !== 'string' || !parsed.user) return null
    return parsed
  } catch (err) {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/bwHandoff.js